import { PayloadAction } from "@reduxjs/toolkit"
import {
	BikeLabelOrderState,
	InformationBiling,
	InformationBilingType,
	ErrorsBilingOrderFormCollection,
	BikeLabelOrderIndexStepEnum,
	NotActiveOrderType,
} from "../types"
import { QuantityLimitEnum } from "../constants"
import { initialStateOrderStep } from "./bikeLabelOrderSlice"

type setProductQuantityActionPayload = PayloadAction<{ id: string; val: number }>
type UpdateOrderBillingActionPayload = PayloadAction<
	InformationBiling & { sepaInProgress: boolean }
>

type HandleChangeBilingActionPayload = PayloadAction<{
	name: InformationBilingType
	value: string
}>

type HandeValidationBilingActionPayload = PayloadAction<{
	name: InformationBilingType
	errors: ErrorsBilingOrderFormCollection
}>

type HandleToggleShowLocalBilingErrorActionPayload = PayloadAction<boolean>

type HandleMemorizeLastStepValidateActionPayload = PayloadAction<
	| NotActiveOrderType
	| Exclude<BikeLabelOrderIndexStepEnum, BikeLabelOrderIndexStepEnum.CONFIRMATION_STEP>
>

export const setProductQuantity = (
	state: BikeLabelOrderState,
	action: setProductQuantityActionPayload
) => {
	const indexProduct = state.products.findIndex(
		(product) => product.product_id === action.payload.id
	)
	if (
		action.payload.val >= QuantityLimitEnum.LOWER_LIMIT_QUANTITY ||
		action.payload.val <= QuantityLimitEnum.MAX_LIMT_QUANTITY
	)
		state.products[indexProduct] = {
			...state.products[indexProduct],
			quantity: action.payload.val,
		}
}

export const updateOrderBillingInformation = (
	state: BikeLabelOrderState,
	action: UpdateOrderBillingActionPayload
) => {
	state.sepaInProgress = action.payload.sepaInProgress
	state.invoicing_agent_firstname = action.payload.invoicing_agent_firstname
	state.invoicing_agent_lastname = action.payload.invoicing_agent_lastname
	state.invoicing_agent_mail = action.payload.invoicing_agent_mail
}

export const handleChangeOrderBilingInformation = (
	state: BikeLabelOrderState,
	action: HandleChangeBilingActionPayload
) => {
	state[action.payload.name] = action.payload.value
}

export const handleValidationOrderBilingInformation = (
	state: BikeLabelOrderState,
	action: HandeValidationBilingActionPayload
) => {
	const cleanErrors: ErrorsBilingOrderFormCollection = [
		...state.errorsBilingForm.filter((error) => error.origin !== action.payload.name),
	]
	state.errorsBilingForm = [...cleanErrors, ...action.payload.errors]
}

export const handleToggleShowLocalBilingError = (
	state: BikeLabelOrderState,
	action: HandleToggleShowLocalBilingErrorActionPayload
) => {
	state.localErrorBilingForm = action.payload
}

export const handleMemorizeLastStepValidate = (
	state: BikeLabelOrderState,
	action: HandleMemorizeLastStepValidateActionPayload
) => {
	state.validatedLabelOrderStep = action.payload
}

export const handleFinishOrder = (state: BikeLabelOrderState) => {
	state.finishOrder = true
}

export const handleClearOrderState = () => {
	return initialStateOrderStep
}
